import React, { useState, useEffect, useContext } from 'react';
import axios from '../Common/axios';
import AssetTable from './AssetTable';
import { Button, Input, Select, Modal } from "antd";
import CodeSelect from '../Common/CodeSelect';
import { getFindAssetList, postSaveAsset } from '../Common/api';
import AssetUpload from './AssetUpload.js';
import AppContext from '../../components/AppContext';
import Cookies from 'js-cookie';
import TopMenu from '../Common/TopMenu';
import { getPopupSizeOption } from '../Common/util';
import { fieldRules, validate , addAssetErrorKey} from '../Common/validationObj';
import { useEventSource } from '../Common/useEventSource';
import { getCodeList } from '../Common/codeManager';
import { companyEnvInit } from '../Common/function';

const { Option } = Select;

/** -------------------------------------------------------------------------- **/
const AssetList = () => {
    const myContext = useContext(AppContext);
    //console.log(myContext);

    // 쿠키에서 인증 토큰 값 가져오기
    const authToken = Cookies.get('access_token');
    // 인증 토큰 값이 존재하면 로그인된 상태로 처리
    const authenticated = authToken ? true : false;

    // 변수 선언
    const [companyCode, setCompanyCode] = useState(myContext.companyCode);
    const [companyName, setCompanyName] = useState(myContext.companyName);
    const [assetType, setAssetType] = useState(myContext.assetType);
    const [assetTypeName, setAssetTypeName] = useState(myContext.assetTypeName);
    const [assetSpec, setAssetSpec] = useState(myContext.assetSpec);
    const [assetSpecName, setAssetSpecName] = useState(myContext.assetSpecName);
    const [assetName, setAssetName] = useState('');
    const [assetCd, setAssetCd] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [initChangeData, setInitChangeData] = useState(false);
    const [isDataChange, setIsDataChange] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const titleName="자산 수정";

    // useEventSource((data)=>{
    //     console.log("assetlist / useEventSource---------------------------");
    //     console.log(data);
    // });
    /** -------------------------------------------------------------------------- **/
    // 회사코드 변경
    const onChangeCompanyCode = (value, option) => {
        setCompanyCode(value);
        setCompanyName(option.children[2]);

        myContext.setCompanyCode(value);
        myContext.setCompanyName(option.children[2]);

        companyEnvInit(value, myContext);
    };

    // 화면로딩시 자동조회
    useEffect(() => {
        // 캐시된 코드 목록 갱신 (1분 캐시)
        getCodeList();  
        if (companyCode != '') {
            findAssetList();
        }      
    }, []);

    // 정보 변경시 재조회
    useEffect(() => {
        // 자산정보 조회
        if (isDataChange && companyCode != '') {
            findAssetList();
        }
    }, [isDataChange]);

    
    // 회사코드 또는 자산유형, 자산스펙 변경 시 자동 조회
    useEffect(() => {
        // 회사코드가 있을 때만 조회
        if (companyCode) {
            findAssetList();
        }
    }, [companyCode, assetType, assetSpec]);

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        setAssetType(value);
        setAssetTypeName(option.children[2]);
        myContext.setAssetType(value);
        myContext.setAssetTypeName(option.children[2]);
        
        // 선택자산 초기화
        setSelectedRowKeys([]);

        // 자산유형이 변경되면 자산스펙 초기화
        setAssetSpec('');
        setAssetSpecName('');
        myContext.setAssetSpec('');
        myContext.setAssetSpecName('');
    };

    // 자산스펙 변경
    const onChangeAssetSpec = (value, option) => {
        setAssetSpec(value);
        setAssetSpecName(option.children[2]);
        myContext.setAssetSpec(value);
        myContext.setAssetSpecName(option.children[2]);
    };

    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "assetName") {
            setAssetName(event.target.value);
        } else if (event.target.id == "assetCd") {
            setAssetCd(event.target.value);
        }
    };

    // 검색 클릭 시
    const onClickSearchHandler = () => {
        // 회사, 자산구분 필수조건 체크
        if (companyCode == '') {
            Modal.info({ title: "필수 조회조건을 확인하세요." });
            return;
        }

        // 선택자산 초기화
        setSelectedRowKeys([]);
        // 자산정보 조회
        findAssetList();
    };
   
    // 자산정보 조회 API
    const findAssetList = () => {
        // 회사코드가 없으면 조회하지 않음
        if (!companyCode) return;
        
        setIsLoading(true);
        setDataSource([]);
        setIsDataChange(false);
        
        axios.get(getFindAssetList(companyCode, assetType, assetName, assetCd, assetSpec)).then((response) => {
            setDataSource(response.data);

            if (response.data.totalCount == 0) {
                Modal.info({ title:titleName, content:"데이터가 없습니다.", okText: "Close" });
            }
        }).catch((error) => {
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
        });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {
        // 변경건이 있으면 추가
        if (saveData.length > 0) {
            saveAssetList(saveData);
        } else {
            Modal.info({ title:titleName, content:"변경된 데이타가 없습니다.", okText: "Close" });
        }
    }

    // 자산정보 등록/수정/삭제 API
    const saveAssetList = (saveData) => {
        setIsDataChange(false);

        const checkData = async() => {
            for(let item of saveData){
                if(item.operation === "D") return "";

                for (let key in fieldRules) {
                    const errormsg =  await validate(item[key], fieldRules[key]);
                    if (errormsg.length > 0) {
                        return [key, errormsg[0]];
                    }
                }
            };
            return "";
        }
        
        checkData().then(errormsg => {
            if(errormsg.length > 0){
                Modal.info({ title:titleName, content:"다음과 같은 입력 오류가 빌생 [ "+addAssetErrorKey[errormsg[0]]+" : "+errormsg[1]+" ]", okText: "Close" });
                // alert("다음과 같은 입력 오류가 빌생 [ "+addAssetErrorKey[errormsg[0]]+" : "+errormsg[1]+" ]");
                return;
            }

            axios.post(postSaveAsset(), saveData, { logCompany: companyCode, logParam: assetTypeName })
                .then((response) => {
                    if (response.data.status === 'success') {
                        //정상적으로 처리된 경우, 재조회
                        Modal.info({
                            title:titleName, content:"자산이 수정 되었습니다.", okText: "Close", onOk() {
                                setIsDataChange(true);
                            }
                        });
                    } else {
                        Modal.info({
                            title:titleName, content:response.data.message, okText: "Close", onOk() {
                                setIsDataChange(true);
                            }
                        });
                    }
                })
                .catch((error) => {
                    if(error.response.data.status === 'fail') {
                        Modal.error({ title:titleName, content:error.response.data.message, okText: "Close" });
                    }else{
                        Modal.error({ title:titleName, content:error.message, okText: "Close" });
                    }
                });
        });

    };

    // 자산등록 클릭 시
    const onClickInsertHandler = async () => {

        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({ title:titleName, content:"회사 조건을 확인하세요." });
            return;
        }
        // 자산구분이 필수 조건이였지만 현재는 자산 구분없이 등록 가능함
        // if (assetType == '') {
        //     Modal.info({ title:titleName, content:"자산구분을 선택해 주세요." });
        //     return;
        // }


        // const _width = '50%';
        // const _height = '800';
        // const _left = Math.ceil(( window.screen.width - _width )/2);
        // const _top = Math.ceil(( window.screen.height - _height )/2); 
        setIsDataChange(false);
        // window.open('#/asset/upload', 'assetUpload', 'width='+ _width +', height='+ _height +', left=' + _left + ', top='+ _top + 'scrollbars=no');
        setIsOpen(true);
    };
    
    function onClickAssetCommonCodeLink() {    
        var _width = '550';
        var _height = '600';
        const option = getPopupSizeOption(_width, _height);

        const url = '#/help/assetCommonCode';
        const target = 'assetCommonCode';
        window.open(url, target, option);
    };

    return (
        <>
            <TopMenu selectKey='asset' />
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '18%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '18%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '18%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '18%' }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th><span className='req'>*</span>회사</th>
                            <td>
                                <CodeSelect codeType="com_cd"
                                    id="companyCode"
                                    value={companyCode}
                                    disabled={authenticated ? true : false}
                                    onChangeHandler={onChangeCompanyCode}
                                    key={1}
                                />
                            </td>
                            <th>자산구분</th>
                            <td>
                                <CodeSelect codeType="asset_type"
                                    id="assetType"
                                    value={assetType}
                                    disabled={false}
                                    onChangeHandler={onChangeAssetType}
                                    showCompanyIndicator={true}
                                    selectedCompanyCode={companyCode}
                                    key={2}
                                />
                            </td>
                            <th>자산명</th>
                            <td>
                                <Input id="assetName" size="small"
                                    allowClear
                                    value={assetName}
                                    onChange={onChangeInputHandler}
                                    onPressEnter={onClickSearchHandler}
                                    key={3}
                                />
                            </td>
                            <th>자산코드</th>
                            <td>
                                <Input id="assetCd" size="small"
                                    allowClear
                                    value={assetCd}
                                    onChange={onChangeInputHandler}
                                    onPressEnter={onClickSearchHandler}
                                    key={4}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className="search_button">
                    <div className="commontype_list_button">
                        <Button type="default" style={{backgroundColor:"#aabbff"}}onClick={onClickAssetCommonCodeLink}>자산구분·유형 보기</Button>
                    </div>
                    <Button type="default" onClick={onClickSearchHandler}>조회</Button>
                    <Button type="primary" onClick={onClickInsertHandler}>자산 등록</Button>
                </div>
            </div>
            <div className="section">
                <AssetTable
                    data={dataSource}
                    companyCode={companyCode}
                    assetType={assetType}
                    rowKey="asset_cd"
                    isLoading={isLoading}
                    initChangeData={initChangeData}
                    onClickSaveHandler={onClickSaveHandler}
                    selectedRowKeys={selectedRowKeys}
                    setSelectedRowKeys={setSelectedRowKeys} />
            </div>
            {isOpen && (<AssetUpload
                open={isOpen}
                rowKey="id"
                p_companyCode={companyCode}
                p_companyName={companyName}
                p_assetType={assetType}
                p_assetTypeName={assetTypeName}
                onClose={(p_isChange) => {
                    setIsOpen(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
        </>

    );
}
export default AssetList;